<template>
	<div
		ref="dropdown"
		class="cursor-default package-dropdown bg-white position-fixed w-100 h-100"
		style="display: none"
		@click.stop="() => {}"
	>
		<div
			class="inner-wrapper px-1 pt-3 pb-3 d-flex align-items-center flex-column h-100"
		>
			<div class="row mb-4 w-100">
				<div class="col-12 px-2 d-flex flex-row nowrap justify-content-between">
					<span class="font-weight-600 font-18 text-start">{{
						content.planningSearch_packagesContents_whatFormula
					}}</span>
					<div class="p-1 cursor-pointer">
						<ClsBtn @click="handleClose" />
					</div>
				</div>
			</div>
			<div class="packages-dropdown-grid container px-2 mb-2 h-100">
				<div class="packages-list">
					<div
						class="w-100"
						v-for="(packObj, packObj_i) in orderedPackCode"
						:key="packObj_i"
					>
						<div
							@click.stop="() => handlePackageClick(packObj)"
							class="option cursor-pointer col-12 d-flex flex-row justify-content-start px-0"
						>
							<RadioCircle
								:active="packObj.codePackage === data.packObj.codePackage"
								:additionalClasses="'me-2'"
								:colorDefault="colors.darkBlue"
								:colorActive="colors.darkBlue"
								:borderSizeActive="'5px solid'"
							/>
							<div class="font-weight-600 font-size-16 text-start">
								{{ getPackNameForCode(packObj.codePackage) }}
							</div>
							<div class="d-flex justify-content-start align-items-center">
								<div
									v-if="
										packObj.codePackage !== 'HS' &&
										promos[packObj.codePackage] &&
										promos[packObj.codePackage] >= 5
									"
									class="d-flex align-items-center justify-content-center prestation-discount-container f bg-primary-green ms-3 ms-xl-3"
								>
									<div
										class="prestation-discount subcaption-strong text-primary-white px-2 py-1 text-nowrap"
										v-bind:class="addDnoneClassIfABtest"
									>
										-{{ promos[packObj.codePackage] }}%
									</div>
								</div>
							</div>
						</div>

						<BorderHorizontal
							v-if="packObj_i !== availablePackCodes.length - 1"
							:classes="'w-100'"
						/>
					</div>
				</div>

				<div
					@click.stop="handleValidateClick"
					class="valider cursor-pointer mt-4 button-primary primary-normal text-white w-100 d-flex flex-row nowrap align-items-center justify-content-center border-light-blue border border-1 py-3 py-mlgd-2 px-4"
				>
					<span class="font-weight-600 font-size-16">{{
						content.planner_datePickerValidateChoice
					}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BorderHorizontal from "@/vue/common/borderHorizontal.vue"
import RadioCircle from "@/vue/common/radioCircle.vue"
import colors from "@/config/colors"
import ClsBtn from "@/vue/common/clsBtn"
import { mapState, mapGetters } from "vuex"
import store from "@/vue/planning/store/store"
import { isABtest } from "@/utils/utils"

export default {
	store,
	name: "PackagesMobileDropdown",
	components: {
		BorderHorizontal,
		RadioCircle,
		ClsBtn,
	},

	computed: {
		...mapState(["content", "packCode", "packagesMobileDropdownOpen"]),
		...mapGetters([
			"maxPromosFromAvailablePackages",
			"availablePackCodes",
			"packNames",
		]),
		orderedPackCode() {
			const packCodes = JSON.parse(JSON.stringify(this.availablePackCodes))

			// make HS package last in list
			return packCodes.sort((a, b) => {
				if (a.codePackage === "HS") return 1
				if (b.codePackage === "HS") return -1
				return 0
			})
		},
		promos() {
			const promoObject = {}
			this.availablePackCodes.forEach((packObj) => {
				promoObject[packObj.codePackage] =
					this.maxPromosFromAvailablePackages[packObj.codePackage]
			})
			return promoObject
		},
		addDnoneClassIfABtest() {
			const dNoneClass = isABtest() ? "d-none !important" : ""
			return dNoneClass
		},
	},

	data() {
		return {
			colors,
			data: {
				packObj: {},
			},
		}
	},

	watch: {
		packagesMobileDropdownOpen(newValue) {
			if (newValue) {
				this.data.packObj = this.availablePackCodes.find(
					(packObj) => packObj.codePackage === this.packCode
				)
				this.show()
			} else {
				this.hide()
			}
		},
	},

	methods: {
		show(display = "block") {
			this.$refs["dropdown"].style.display = display
		},
		hide() {
			this.$refs["dropdown"].style.display = "none"
		},
		handleClose() {
			this.$store.dispatch("setPackagesMobileDropdownOpen", false)
		},
		handlePackageClick(packObj) {
			this.data.packObj = packObj
		},
		handleValidateClick() {
			this.$emit("validateClick", this.data.packObj)
		},
		getPackNameForCode(packCode) {
			return this.packNames[packCode]
		},
	},
}
</script>

<style scoped>
.cls {
	user-select: none;
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	touch-action: manipulation;
}

.valider {
	touch-action: manipulation;
}

.option {
	touch-action: manipulation;
}

.package-dropdown {
	z-index: 100001 !important;
	top: 0;
	left: 0;
	box-shadow: 0px 0px 4px 0px gray;
	transition: opacity 150ms ease-in-out;
}

.packages-dropdown-grid {
	display: grid;
	grid-template-rows: 0.9fr 70px;
}

.prestation-discount-container {
	border-radius: 37px;
}
</style>
